import { RNSAPI } from '../../api';
import { UserData } from '../../UserData';
import { Utils } from '../../utils';
import { MainViewModel } from "../../main";
import * as fs from "fs";
import * as ko from "knockout";
import * as moment from 'moment';
import '../document/pdfjs';
import '../document/wopi';
import '../zpe/mail';
import './caseentry';
import '../workflow/stamps';
import '../workflow/header';
import '../view/select';
import '../tag/assign';
import { CaseOverviewViewModel } from './overview';
import { StampsViewModel, stampContainerWidth } from '../workflow/stamps';
import { start } from 'repl';

//Server Side filter
export class Filter {
    CaseId: string;
    StartDate: string;
    EndDate: string;
    ShorthandSymbol: string;
    Workflow: string;
    Dictation: string;
    View: string;
    Limit: number;

    constructor(caseId: string, startDate: string, endDate: string, shorthandSymbol: string, workflow: string, dictation: string, view: string, limit: number) {
        this.CaseId = caseId;
        this.StartDate = startDate;
        this.EndDate = endDate;
        this.ShorthandSymbol = shorthandSymbol;
        this.Workflow = workflow;
        this.Dictation = dictation;
        this.View = view;
        this.Limit = limit;
    }
}

enum DisplayMode {
    Overview = 1,
    Wfk = 2
}

class CaseEntryOverviewViewModel {
    private readonly limit = 100;
    currentFilter = ko.observable(new Filter(null, null, null, null, null, null, null, this.limit));

    filterCaseId = ko.observable("");
    filterStartDate = ko.observable("");
    filterEndDate = ko.observable("");
    filterShorthandSymbol = ko.observable("");
    filterWorkflow = ko.observable("");
    filterDictation = ko.observable("");
    filterInputs = [this.filterCaseId, this.filterStartDate, this.filterEndDate, this.filterShorthandSymbol, this.filterWorkflow, this.filterDictation];


    wopiToken = {
        "AccessToken": "",
        "AccessTokenTtl": 0
    }
    caseEntries: KnockoutObservableArray<any>
    currentId = ko.observable(null);
    currentMode = ko.observable(DisplayMode.Overview);
    //why is currentMargin necessary? This is necessary because the flexbox css model is not powerful enough
    //CSS Grid would be powerful enough, but is not supported in older browsers
    currentMargin = ko.computed(() => {
        switch (this.currentMode()) {
            case DisplayMode.Overview:
                return "191px";
            case DisplayMode.Wfk:
                return "135px";
            default:
                return "0";
        }
    });
    currentViewer = ko.observable("pdf");
    currentMimeType = ko.observable(null);
    wfk = ko.observable("");

    //expose to knockout
    trunc = Utils.trunc
    DisplayMode = DisplayMode

    stampContainerSize = ko.observable(stampContainerWidth);
    containerWidth = ko.computed(() => `calc(100% - ${this.stampContainerSize()}`);

    modalTitle = ko.observable("Workflow Mark");
    modalKeys = ko.observableArray(["WFK"]);
    modalColumns = ko.observableArray(["WFK"]);
    modalData = ko.observableArray([]);
    modalHandleSelection: KnockoutObservable<(selectedObject: any) => void> = ko.observable();

    async remove(id: string) {
        await RNSAPI.deleteRecord(id);
        await this.loadEntries(this.currentFilter());
    }

    async download(name: string, id: string) {
        let element = document.createElement('a');
        let doc = (await RNSAPI.getDocumentData(id)).Payload.Document;

        //server side bug in the ActiveX Component => OleType is doc instead of rtf
        let IsRTF = atob(doc.DocumentData.substr(0, 50)).indexOf("rtf") !== -1;
        let type = IsRTF ? "rtf" : doc.OLE2Type.trim().toLowerCase();

        let blob = Utils.base64ToBlob(doc.DocumentData, 'application/octet-stream');

        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveOrOpenBlob(blob);
        } else {
            element.setAttribute('href', 'data:application/octet-stream;charset=utf-16le;base64,' + doc.DocumentData);
            element.setAttribute('download', `${name.trim()}.${type}`);

            element.style.display = 'none';
            document.body.appendChild(element);

            element.click();

            document.body.removeChild(element);
        }
    }

    async loadEntries(filter: Filter) {
        try {
            let entries = (await RNSAPI.getCaseEntriesForFilter(filter)).Payload.Records
                .filter((entry) => {
                    return entry.MimeType.indexOf("application/vnd.renostar.xmp") === -1;
                })
                .sort((a, b) => {
                    let dateA = new Date(a.LastChange || a.DocumentDate || a.RecordDate);
                    let dateB = new Date(b.LastChange || b.DocumentDate || b.RecordDate);
                    if (dateA < dateB) return 1;
                    else if (dateA > dateB) return -1;
                    else return 0
                })
                .map((entry) => {
                    entry.DocumentDate = (new Date(entry.LastChange || entry.DocumentDate || entry.RecordDate)).toLocaleDateString();
                    entry.columnActions = {
                        "CaseId": MainViewModel.RoutingTable.generateLink(`/case/${encodeURIComponent(entry.CaseId)}`)
                    };
                    entry.actionHandlers = [{
                        'icon': 'pencil',
                        'name': 'Edit',
                        'action': () => {
                            MainViewModel.RoutingTable.showCaseEntryView({ caseId: entry.CaseId, eCaseRecordId: entry.Id });
                        }
                    }, {
                        'icon': 'tags',
                        'name': 'Tags',
                        'action': () => {
                            this.currentId(entry.Id);
                            this.currentId.valueHasMutated();
                            $("#assignTags").modal('show');
                        }
                    }, {
                        'icon': 'paperclip',
                        'name': 'Workflow',
                        'action': () => {
                            this.mark(entry.Id, entry.CaseId);
                        }
                    }, {
                        'icon': 'download',
                        'name': 'Download',
                        'action': () => {
                            this.download(entry.Subject, entry.Id);
                        }
                    }, {
                        'icon': 'trash',
                        'name': 'Löschen',
                        'action': () => {
                            this.remove(entry.Id);
                        }
                    }];

                    if (Utils.matchAny(entry.MimeType.toLowerCase(), Utils.AcceptedMimeTypes)) {
                        entry.actionHandlers.unshift({
                            'icon': 'eye',
                            'selectable': true,
                            'name': 'Vorschau',
                            'action': () => {
                                //set an non existent viewer to trigger the dispose methods
                                //before the id is set, otherwise, the old subscriptions will be called again
                                this.currentViewer("");
                                this.currentMimeType(entry.MimeType.toLowerCase());
                                this.currentId(entry.Id);
                                if (entry.MimeType.toLowerCase().indexOf("pdf") !== -1) {
                                    this.currentViewer("pdf");
                                } else if (entry.MimeType.toLowerCase().indexOf("rfc822") !== -1) {
                                    this.currentViewer("mail");
                                } else if (entry.MimeType.toLowerCase().indexOf("audio/ogg") !== -1) {
                                    this.currentViewer("play");
                                } else {
                                    this.currentViewer("wopi");
                                }
                            }
                        });
                    }

                    if (entry.WorkflowId === "V") {
                        entry.actionHandlers.push({
                            'icon': 'envelope',
                            'name': 'Versenden',
                            'action': () => {
                                MainViewModel.RoutingTable.showComposeView({
                                    caseId: entry.CaseId,
                                    eCaseRecordId: entry.Id
                                });
                            }
                        });
                    }

                    //add a "mark dictation as done button" when necessary
                    if (entry.MimeType.toLowerCase() === "audio/ogg" && entry.WorkflowId !== 'E' && !entry.TypistId) {
                        entry.actionHandlers.push({
                            'icon': 'check',
                            'name': 'Erledigen',
                            'action': async () => {
                                await RNSAPI.markDictationAsDone(entry.Id);
                                this.loadEntries(this.currentFilter());
                            }
                        });
                    }

                    return entry;
                });

            this.caseEntries(entries);
        } catch (e) {
            alert("Laden der Akteneinträge fehlgeschlagen.");
        }
    }

    mark(entryId: string, caseId: string): void {
        if (this.modalData().length == 1) {
            this.setMark(entryId, this.modalData()[0].WFK);
        } else {
            this.modalHandleSelection((selectedObject) => {
                this.setMark(entryId, selectedObject().WFK);
            });
            $('#modal').modal('show');
        }
    }

    async setMark(entryId: string, mark: string) {
        await RNSAPI.setCaseEntryWorkflowMark(entryId, mark);
        this.loadEntries(this.currentFilter());
    }

    public getVM = () => this;

    private readonly wfkOutMap = {
        "PE": ["B", "RA"],
        "ZU": ["B", "V"],
        "PA": ["E"],
        "RA": ["B", "V"],
        "B": ["ZU", "RA"],
        "E": [],
        "V": ["PA"]
    }

    constructor(params: any) {
        this.caseEntries = ko.observableArray([]);
        //helper to transform "" into null, so the server parses it as Optional.None
        let n = (s: string) => s ? s : null;

        this.currentFilter.subscribe(newFilter => this.loadEntries(newFilter));

        for (let filterInput of this.filterInputs) {
            filterInput.subscribe(newValue => {

                let startDateInput = n(this.filterStartDate());
                let startDate = null;
                let endDateInput = n(this.filterEndDate());
                let endDate = null;

                if (startDateInput) {
                    let startDateMoment = moment(startDateInput, "DD.MM.YYYY", true);
                    if (startDateMoment.isValid()) {
                        startDate = startDateMoment.format("YYYY-MM-DD");
                    } else {
                        alert("Startdatum ist ungültig.");
                    }
                }

                if (endDateInput) {
                    let endDateMoment = moment(endDateInput, "DD.MM.YYYY", true);
                    if (endDateMoment.isValid()) {
                        endDate = endDateMoment.format("YYYY-MM-DD");
                    } else {
                        alert("Enddatum ist ungültig.");
                    }
                }

                this.currentFilter(new Filter(n(this.filterCaseId()), startDate, endDate, n(this.filterShorthandSymbol()), n(this.filterWorkflow()), n(this.filterDictation()), this.currentFilter().View, this.limit));
            });
        }

        if (params && params.workflow) {
            this.currentMode(DisplayMode.Wfk);
            this.filterWorkflow(params.workflow);
            this.modalData(this.wfkOutMap[params.workflow].map(wfk => { return { WFK: wfk }; }));
        } else {
            this.modalData(Object.keys(this.wfkOutMap).map(wfk => { return { WFK: wfk }; }));
        }

        this.loadEntries(this.currentFilter());
    }
}

let html = fs.readFileSync(__dirname + '/caseentryoverview.html', 'utf8');

ko.components.register("caseentryoverview-view", {
    viewModel: CaseEntryOverviewViewModel,
    template: html
});
